
if (!customElements.get('event-countdown')) {
  class BannerCountdown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.start_time = this.getAttribute('start_time') || '';
      this.now_time = this.getAttribute('now_time') || new Date().toISOString();
      this.Countdown_time = this.getAttribute('Countdown_time') || '';
      this.sectionId = this.getAttribute('section_id') || '';

      if (this.Countdown_time) {
        this.CountDownStart();
      }
    }

    disconnectedCallback() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }

    CountDownStart() {
      let now_time = Date.parse(this.now_time);
      let Countdown_time = Date.parse(this.Countdown_time);
      let start_time = Date.parse(this.start_time);
      
      let total_duration = Countdown_time - start_time;
      let remaining_time = Countdown_time - now_time;

      if (isNaN(now_time) || isNaN(Countdown_time) || now_time > Countdown_time || now_time < start_time) {
        this.style.display = 'none';
        this.toggleProgressContainer(false);
        return;
      }
      
      this.style.display = 'flex';

      this.updateUI(remaining_time, total_duration);

      this.timer = setInterval(() => {
        remaining_time -= 1000;
        
        if (remaining_time <= 0) {
          this.style.display = 'none';
          this.toggleProgressContainer(false);
          clearInterval(this.timer);
          return;
        }

        this.updateUI(remaining_time, total_duration);
      }, 1000);
    }

    updateUI(remaining, total) {
      const time_obj = this.get_compare_time(remaining);
      const daysEl = this.querySelector('#Countdown_days');
      const hoursEl = this.querySelector('#Countdown_hours');
      const minsEl = this.querySelector('#Countdown_minutes');
      const secsEl = this.querySelector('#Countdown_seconds');

      if (daysEl) daysEl.innerText = time_obj.DD < 10 ? '0' + time_obj.DD : time_obj.DD;
      if (hoursEl) hoursEl.innerText = time_obj.HH < 10 ? '0' + time_obj.HH : time_obj.HH;
      if (minsEl) minsEl.innerText = time_obj.MM < 10 ? '0' + time_obj.MM : time_obj.MM;
      if (secsEl) secsEl.innerText = time_obj.SS < 10 ? '0' + time_obj.SS : time_obj.SS;

      // 2. 更新关联的进度条（通过 sectionId 绑定）
      if (!this.sectionId || total <= 0) return;

      const progressFill = document.querySelector(`#Progress_fill_${this.sectionId}`);
      const stepNodes = document.querySelectorAll(`#Progress_nodes_${this.sectionId} .step_node`);

      if (progressFill) {
        let percentage = (remaining / total) * 100;
        percentage = Math.max(0, Math.min(100, percentage));
        progressFill.style.width = percentage + '%';

        if (stepNodes.length > 0) {
          const totalSteps = stepNodes.length;
          stepNodes.forEach((node, index) => {
            let nodePercentage = (index / (totalSteps - 1)) * 100;
            if (percentage >= nodePercentage) {
              node.classList.add('is-active');
            } else {
              node.classList.remove('is-active', 'is-current');
            }
          });
        }
      }
    }

    toggleProgressContainer(show) {
      if (!this.sectionId) return;
      const progressContainer = document.querySelector(`#Progress_container_${this.sectionId}`);
      if (progressContainer) {
        progressContainer.style.display = show ? 'block' : 'none';
      }
    }

    get_compare_time(time) {
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      return {
        DD: Math.floor(time / day),
        HH: Math.floor((time % day) / hour),
        MM: Math.floor((time % hour) / minute),
        SS: Math.floor((time % minute) / second),
      };
    }
  }

  window.customElements.define('event-countdown', BannerCountdown);
}